export const ActionType = {
    SET_PRODUCTS: 'SET_PRODUCTS',
    SET_ORDER: 'ADD_TO_ORDER'
}